/**
 * Created by vladislav on 04/01/22
 */

const CupComponent = function (unit, options) {
    UnitComponent.call(this, unit);

    const data = unit.getData();

    this.amount = options.amount === undefined ? data.cup.amount : options.amount;

    if (this.isEmpty()) {
        setTimeout(this.remove.bind(this, true), 0);
    }
};

CupComponent.prototype = Object.create(UnitComponent.prototype);
CupComponent.prototype.constructor = CupComponent;

CupComponent.prototype.onUpdateState = function () {
    if (this.view) {
        this.view.restoreState(true);
    }
};

CupComponent.prototype.save = function (data) {
    data.amount = this.amount;
};

CupComponent.prototype.handleClick = function () {
    const selection = Merge2.current.field.lastSelection;
    if (!selection || this.unit.x !== selection.x || this.unit.y !== selection.y) {
        return false;
    }

    this.unit.squeeze();
    this.spendCharge();

    return true;
};

CupComponent.prototype.remove = function (silent) {
    if (silent) {
        this.unit.onRemove();
    } else {
        this.onDestruction();
        this.unit.onDestruction();
    }
    this.unit.remove(true);
};

CupComponent.prototype.canSpend = function () {
    const lock = this.unit.findComponent(LockedComponent);
    if (lock && lock.isLocked()) {
        return false;
    }

    return !this.isEmpty() && Merge2.current.field.countEmptySlots() > 0;
};

CupComponent.prototype.spendCharge = function () {
    if (!this.canSpend()) {
        return;
    }

    const data = this.unit.getData().cup;
    const unit = data.units[this.pickUnitIndex(data)];

    const remains = Merge2.current.spawn([unit], this.unit);
    if (remains.length > 0) {
        return;
    }

    this.amount--;

    this.unit.save();

    if (this.isEmpty()) {
        this.remove();
    }

    this.onUpdateState();
};

CupComponent.FilterProbabilities = function (probabilities, units, filter) {
    const filtered = probabilities.map((probability, index) => (filter(units[index]) ? probability : 0));
    const total = filtered.reduce((sum, probability) => sum + probability, 0);
    if (total === 0) {
        return undefined;
    }

    return filtered.map((probability) => probability / total);
};

CupComponent.prototype.pickUnitIndex = function (data) {
    let probabilities = data.probabilities;

    if (data.openedOnly) {
        probabilities = CupComponent.FilterProbabilities(probabilities, data.units, (unit) => cleverapps.unitsLibrary.isOpened(unit))
            || CupComponent.FilterProbabilities(probabilities, data.units, (unit) => CupComponent.BASE_CODES.includes(unit.code))
            || probabilities;
    }

    if (data.ordersOnly) {
        probabilities = CupComponent.FilterProbabilities(probabilities, data.units, (unit) => Merge2.current.customers.isUnitNeeded(unit)) || probabilities;
    }

    return PseudoRandom.GET().pickOne(probabilities);
};

CupComponent.prototype.isFull = function () {
    return this.amount >= this.unit.getData().cup.amount;
};

CupComponent.prototype.isEmpty = function () {
    return this.amount < 1;
};

CupComponent.prototype.onDestruction = function () {
    if (this.view) {
        this.view.playDestruction();
    }
};

CupComponent.prototype.isMergeable = function () {
    return this.isFull();
};

CupComponent.BASE_CODES = ["a", "b"];